import { LegalLayout, headingStyle, paragraphStyle, sectionStyle, listStyle } from "./LegalLayout";

export function TermsOfServicePage() {
  return (
    <LegalLayout title="Пользовательское соглашение">
      <section style={sectionStyle}>
        <h2 style={headingStyle}>Общие положения</h2>
        <p style={paragraphStyle}>
          Настоящее соглашение регулирует использование Hockey Planner. Доступ к функциям сервиса предоставляется пользователям бесплатно.
        </p>
      </section>

      <section style={sectionStyle}>
        <h2 style={headingStyle}>Правила использования</h2>
        <ul style={listStyle}>
          <li>пользователь обязуется указывать достоверные данные и поддерживать их актуальность;</li>
          <li>пользователь отвечает за действия, совершённые через его аккаунт;</li>
          <li>запрещено использовать сервис для незаконных действий, спама, вмешательства в работу приложения или доступа к чужим данным;</li>
          <li>при размещении данных игроков и команд пользователь должен иметь необходимые права и основания для такого размещения.</li>
        </ul>
      </section>

      <section style={sectionStyle}>
        <h2 style={headingStyle}>Права и обязанности сервиса</h2>
        <p style={paragraphStyle}>
          Hockey Planner предоставляет доступ к функциональности сервиса, развивает приложение, исправляет ошибки и может изменять интерфейс, функции,
          правила доступа и техническую инфраструктуру. Отдельные функции могут быть изменены, ограничены или прекращены.
        </p>
      </section>

      <section style={sectionStyle}>
        <h2 style={headingStyle}>Ограничение ответственности</h2>
        <p style={paragraphStyle}>
          Сервис предоставляется в электронном виде. Hockey Planner стремится обеспечивать стабильную работу, но не гарантирует отсутствие временных сбоев,
          ошибок, перерывов связи или ограничений, вызванных сторонними сервисами, устройствами пользователя или обстоятельствами вне разумного контроля.
        </p>
      </section>

      <section style={sectionStyle}>
        <h2 style={headingStyle}>Прекращение использования</h2>
        <p style={paragraphStyle}>
          Пользователь может прекратить использование сервиса. Hockey Planner может ограничить доступ при нарушении соглашения, угрозе безопасности,
          злоупотреблениях или по иным основаниям, предусмотренным законом и условиями сервиса.
        </p>
      </section>

      <section style={sectionStyle}>
        <h2 style={headingStyle}>Изменение условий</h2>
        <p style={paragraphStyle}>
          Условия использования могут обновляться. Актуальная версия публикуется на этой странице и применяется с даты, указанной в документе.
        </p>
      </section>
    </LegalLayout>
  );
}
